export const CAMERA_FRAMING_MINIMUM_DEPTH = 0.1;
